export default "__VITE_ASSET__Brw2Be77__"